import React, { useState } from 'react';
import { FiAward, FiCheck } from 'react-icons/fi';
import { VscGame } from 'react-icons/vsc';
import { Avatar } from '@/components/custom/avatar/avatar';
import { Badge } from '@/components/ui/badge';
import { PlayfulCardButton } from '@/components/custom/playful-card';
import MatterModal from '../MatterModal';

export default function ParticipantSummary({ studentChallenge, showTrophy, isStudent, selectedTab }) {
  const [showModal, setShowModal] = useState(false);

  const highlights = studentChallenge?.['accuracy-rate-highlights'];
  const topHighlights = highlights ? [...highlights].sort((a, b) => b['question-accuracy'] - a['question-accuracy']).slice(0, 2) : [];
  const isStudentResult = isStudent || selectedTab === 'resultados';

  return (
    <>
      <section
        className="relative mb-6 flex flex-col overflow-hidden rounded-[24px] border border-neutral-100 bg-[var(--color-bg-cream)] p-6 shadow-card md:p-8"
        style={{ animation: 'trilha-in 380ms cubic-bezier(0.23, 1, 0.32, 1) 150ms both' }}
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 top-0 h-20 rounded-t-[24px]"
          style={{ background: 'linear-gradient(180deg, rgba(214,253,255,0.5) 0%, transparent 100%)' }}
        />

        <div className="relative grid gap-6 lg:grid-cols-[minmax(260px,1.25fr)_minmax(260px,0.9fr)_minmax(260px,1fr)] lg:items-start">
          <div className="flex min-w-0 items-center gap-4">
            <Avatar
              src={studentChallenge?.user?.image}
              alt="Imagem do participante"
              size="lg"
            />

            <div className="min-w-0">
              <div className="mb-1 flex flex-wrap items-center gap-2">
                <p className="mb-0 text-xs font-bold text-neutral-500">{isStudentResult ? 'Estudante' : 'Professor'}</p>
                {showTrophy && (
                  <Badge
                    variant="amber-soft"
                    size="sm"
                  >
                    Posição {showTrophy}
                  </Badge>
                )}
              </div>
              <h1
                className="mb-2 truncate text-xl font-extrabold"
                style={{ color: '#222731' }}
                title={studentChallenge?.user?.name}
              >
                {studentChallenge?.user?.name}
              </h1>
              <p className="mb-1 truncate text-sm font-bold text-neutral-600">{studentChallenge?.courses?.[0]}</p>
              <p className="mb-1 truncate text-xs font-semibold text-neutral-500">{studentChallenge?.institutions?.[0]}</p>
              <p className="mb-0 truncate text-xs font-semibold text-neutral-500">{studentChallenge?.regionals?.[0]}</p>
            </div>
          </div>

          <div>
            <p className="mb-3 text-xs font-bold text-neutral-500">Geral</p>
            <div className="grid grid-cols-2 gap-3">
              <div className="min-h-[112px] rounded-[16px] border border-neutral-100 bg-white/80 p-4 shadow-sm">
                <div className="mb-2 flex items-center gap-2">
                  <VscGame className="h-5 w-5 shrink-0 text-mission" />
                  <p className="mb-0 text-xs font-bold text-neutral-500">{isStudentResult ? 'Desafios' : 'Desafios criados'}</p>
                </div>
                <p className="mb-0 text-center text-2xl font-extrabold text-neutral-800">{studentChallenge?.['challenge-attempt-count'] ?? 0}</p>
              </div>
              <div className="min-h-[112px] rounded-[16px] border border-neutral-100 bg-white/80 p-4 shadow-sm">
                <div className="mb-2 flex items-center gap-2">
                  <FiCheck className="h-5 w-5 shrink-0 text-success" />
                  <p className="mb-0 text-xs font-bold text-neutral-500">{isStudentResult ? 'Acertos' : 'Acertos dos estudantes'}</p>
                </div>
                <p className="mb-0 text-center text-2xl font-extrabold text-neutral-800">{studentChallenge?.['accuracy-rate'] ?? 0}%</p>
              </div>
            </div>
          </div>

          <div>
            <p className="mb-3 text-xs font-bold text-neutral-500">Destaques</p>
            <div className="flex flex-col gap-2">
              {topHighlights.map(highlight => (
                <div
                  key={highlight.taxonomy}
                  className="flex items-center gap-3 rounded-[14px] border border-neutral-100 bg-white/80 px-3 py-2 shadow-sm"
                >
                  <FiAward className="h-5 w-5 shrink-0 text-mission" />
                  <span className="min-w-0 flex-1 truncate text-sm font-bold text-neutral-700">{highlight.taxonomy}</span>
                  <Badge
                    variant={highlight['question-accuracy'] > 66 ? 'success-soft' : highlight['question-accuracy'] > 33 ? 'amber-soft' : 'danger-soft'}
                    size="sm"
                  >
                    {highlight['question-accuracy']}%
                  </Badge>
                </div>
              ))}

              <PlayfulCardButton
                variant="outline"
                className="h-8 w-auto self-center px-4 py-1.5 text-xs"
                onClick={() => setShowModal(true)}
              >
                Ver mais destaques
              </PlayfulCardButton>
            </div>
          </div>
        </div>
      </section>

      <MatterModal
        playful
        challenges={highlights}
        show={showModal}
        onClose={() => setShowModal(false)}
        isStudent={isStudent}
        selectedTab={selectedTab}
      />
    </>
  );
}
